export { default } from './styled-components-registry';
